module.exports = __webpack_public_path__ + "img/img-45.8ac47b86.png";